<template>
  <v-theme-provider dark>
    <v-card-actions class="primary pl-1">
      <h-confirm
        v-model="removeDialog"
        :title="__('areYouSure')"
        :text="__('deleteOrderContents')"
        @yes="removeAll()"
        @no="removeDialog = false"
      />
      <v-menu
        v-if="showMore"
        light
        max-width="380"
      >
        <template #activator="{ on, attrs }">
          <v-btn
            v-on="on"
            v-bind="attrs"
            icon
            large
            :disabled="disabled"
          >
            <v-icon v-text="icons.moreVertical" />
          </v-btn>
        </template>
        <v-list>
          <v-list-item
            v-if="canRemoveOrderContents"
            :disabled="order.isEmpty"
            @click="removeDialog = true"
          >
            <v-list-item-icon><v-icon v-text="icons.delete" /></v-list-item-icon>
            <v-list-item-title>{{ __('deleteAllContents') }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-spacer />
      <h-kitchen-notes @select="$emit('sendnote', $event)">
        <template #activator="{ on, attrs }">
          <v-btn
            icon
            large
            :disabled="disabled"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon v-text="icons.kitchenNote" />
          </v-btn>
        </template>
      </h-kitchen-notes>
      <v-btn
        v-if="showSendToKitchen"
        icon
        large
        :disabled="disabled"
        @click.stop="sendToKitchen()"
      >
        <v-icon v-text="icons.kitchen" />
      </v-btn>
      <v-btn
        v-if="can('applyDiscounts')"
        icon
        large
        :disabled="disabled"
        @click.stop="$store.dispatch('orders/dialogs/openDiscounts')"
      >
        <v-icon v-text="icons.percent" />
      </v-btn>
      <v-btn
        v-if="can('charge')"
        icon
        large
        :disabled="disabled"
        @click.stop="$emit('pay')"
      >
        <v-icon v-text="icons.coins" />
      </v-btn>
    </v-card-actions>
  </v-theme-provider>
</template>

<script>
  import ComparesVersions from '@/Mixins/ComparesVersions'
  import I18n from '@/Mixins/I18n'
  import Lockable from '@/Mixins/Lockable'
  import NeedsPermission from '@/Mixins/NeedsPermission'
  import UsesIcons from '@/Mixins/UsesIcons'
  import OrderStatus from '@/Models/Static/OrderStatus'
  import FranceLog from '@/Models/Static/FiscalCountry/FranceLog'
  import HConfirm from '@/Components/Messages/Confirm'
  import HKitchenNotes from './KitchenNotes'

  export default {
    mixins: [
      ComparesVersions,
      I18n,
      Lockable,
      NeedsPermission,
      UsesIcons,
    ],

    components: {
      HConfirm,
      HKitchenNotes,
    },

    data: () => ({
      OrderStatus,
      FranceLog,
      removeDialog: false,
    }),

    computed: {
      order () {
        return this.$store.state.orders.current
      },
      disabled () {
        return this.$store.state.orders.dialogs.locked
      },
      showMore () {
        return this.canRemoveOrderContents
      },
      canRemoveOrderContents () {
        return this.order.orderContents.every(content => content.canBeRemoved)
      },
      showSendToKitchen () {
        return this.$page.props.brand === 'HANDY'
            && this.$store.state.workingModes.event === false
      },
    },

    methods: {
      removeAll () {
        this.$log('Removed all items from order', 'Order', this.order.id)
        this.$logFrance(this.FranceLog.ACCOUNTING_TICKET_CANCELLATIONS, `Removed all items from order ${this.order.id}`)
        this.$store.commit('orders/removeContents')
        this.removeDialog = false
      },
      sendToKitchen () {
        if (this.locked) {
          return
        }
        this.lock(400)
        if (this.canSendHandyActions) {
          this.$log('Pending action: printOrder', 'Order', this.order.id)
          this.$store.commit('orders/pendingAction', 'printOrder')
        } else {
          this.$log('Updated order status to SHOULD_BE_PRINTED_IN_THE_KITCHEN', 'Order', this.order.id)
          this.$store.commit('orders/changeStatus', this.OrderStatus.SHOULD_BE_PRINTED_IN_THE_KITCHEN)
        }
        this.$emit('close')
      },
    },
  }
</script>
